import { useState } from "react";

// Extrai o par inputValues/filtros (o que o usuário está digitando vs. o
// que está de fato aplicado, só trocando quando clica "Aplicar") que se
// repetia quase idêntico em toda aba que usa FilterModal — Colaboradores,
// Ausências, Escalas, Usuários, o filtro de equipe do
// vínculo. onChange roda depois de aplicar ou limpar; cada tela decide o
// que precisa (normalmente resetar a página da paginação do servidor).
export function useFilterState<T>(initial: T, onChange?: () => void) {
  const [inputValues, setInputValues] = useState<T>(initial);
  const [filtros, setFiltros] = useState<T>(initial);

  const applyFilters = () => {
    setFiltros(inputValues);
    onChange?.();
  };

  const handleClearFilters = () => {
    setInputValues(initial);
    setFiltros(initial);
    onChange?.();
  };

  return { inputValues, setInputValues, filtros, applyFilters, handleClearFilters };
}
